import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { IAttachmentLocalComputerFilePicker } from 'owa-attachment-filepicker';
import {
    AttachmentSuggestionsMenuItems,
    ReplyWithAttachmentSuggestion,
} from 'owa-attachment-suggestions';
import { ComposeViewState } from 'owa-mail-compose-store';
import getAttachmentPolicy from 'owa-session-store/lib/utils/getAttachmentPolicy';
import { AttachmentMultiMenuMap } from '../types/AttachmentMultiMenuMap';
import { onAttachmentClicked } from './attachButtonMenuItemBuilderUtils';
import { getAttachmentMenuItemsBasedOnClickHandler } from './getAttachmentMenuItemsBasedOnClickHandler';
import { createReplyWithContextualMenuItemSeparator } from './attachButtonMenuItemBuilder';
import { logAttachOrInsertMenuOpened } from './logAttachOrInsertMenuOpened';
import { logAttachOrInsertMenuDismissed } from './logAttachOrInsertMenuDismissed';
import { getAttachAsClassicButtonsList } from './getAttachmentCommandItems';

export function getAttachAsClassicMenuItems(
    composeViewState: ComposeViewState,
    getAttachmentLocalComputerFilePicker: () => IAttachmentLocalComputerFilePicker | null,
    getAttachmentSuggestionsMenuItems: () => AttachmentSuggestionsMenuItems | null,
    targetWindow: Window,
    shouldPlaceSuggestionsInBottom: boolean
): { menuItems: IContextualMenuItem[]; onMenuOpened: () => void; onMenuDismissed: () => void } {
    const attachmentPolicy = getAttachmentPolicy();
    const classicAttachmentsEnabled = attachmentPolicy.ClassicAttachmentsEnabled;
    if (!classicAttachmentsEnabled) {
        return { menuItems: [], onMenuOpened: null, onMenuDismissed: null };
    }

    const attachmentMultiMenuEntriesClickHandler: AttachmentMultiMenuMap<() => void> = {
        computer: () => {
            const localComputerFilePicker = getAttachmentLocalComputerFilePicker();
            localComputerFilePicker?.click();
        },
        onlineLocation: null,
        uploadAndShareFromCloud: null,
    };
    let menuItems: IContextualMenuItem[] = getAttachmentMenuItemsBasedOnClickHandler(
        attachmentMultiMenuEntriesClickHandler
    );

    // Attachment suggestions
    const attachmentSuggestionsMenuItems: AttachmentSuggestionsMenuItems = getAttachmentSuggestionsMenuItems();
    const attachmentSuggestions: IContextualMenuItem[] = attachmentSuggestionsMenuItems?.getContextualMenuItems(
        true /* shouldUseSuggestions */,
        composeViewState.referenceItemId,
        false /* referenceAttachmentsSupported */,
        true /* classicAttachmentsSupported */,
        false /* shouldUseSuggetedFilesTitle */,
        (suggestion: ReplyWithAttachmentSuggestion, suggestionIndex: number) => {
            onAttachmentClicked(suggestion, suggestionIndex, composeViewState);
        }
    );
    if (attachmentSuggestions) {
        if (shouldPlaceSuggestionsInBottom) {
            menuItems.push(...attachmentSuggestions);
        } else {
            menuItems = attachmentSuggestions
                .concat([createReplyWithContextualMenuItemSeparator()])
                .concat(menuItems);
        }
    }
    const onMenuOpened = () =>
        logAttachOrInsertMenuOpened(
            composeViewState,
            getAttachmentSuggestionsMenuItems,
            getAttachAsClassicButtonsList().join(','),
            false /* referenceAttachmentsSupported */,
            true /* classicAttachmentsSupported */
        );
    const onMenuDismissed = () =>
        logAttachOrInsertMenuDismissed(
            composeViewState,
            getAttachmentSuggestionsMenuItems,
            false /* referenceAttachmentsSupported */,
            true /* classicAttachmentsSupported */
        );
    return { menuItems, onMenuOpened, onMenuDismissed };
}
